module.exports = __webpack_public_path__ + "assets/images/ldl_r.e52755c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/ldl_r.png
// module id = 750
// module chunks = 1